import Iconify from "minimals-template/components/Iconify"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { authoringRoute } from "../authoring.runtime"
import { MacrosPage } from "./macro-page"
import { ResolveMacroChipDisplay } from "./macro-events"
import "./feature-flag-component-macros"

authoringRoute.register("macros", <MacrosPage $lazy />)

registerConditionalPageNavigation(() => true, "/authoring/macros", "Macros", <Iconify icon="mdi:code-tags" />, {
    group: "Work Packages",
    priority: 590,
    subPaths: true,
})

// Default chip display for standard macros
ResolveMacroChipDisplay.handleOnce(({ macro, result }) => {
    result.label = macro?.name ?? result.label
    result.background = "rgba(var(--mui-palette-info-mainChannel) / 0.12)"
    result.borderColor = "rgba(var(--mui-palette-info-mainChannel) / 0.3)"
    result.color = "var(--mui-palette-info-dark, #1165B3)"
})

// Component token chip display (cmp: prefix)
ResolveMacroChipDisplay("cmp").handleOnce(({ macro, result }) => {
    if (macro?.broken) {
        result.label = macro?.label ?? `Missing: ${result.label}`
        result.background = "rgba(var(--mui-palette-error-mainChannel) / 0.12)"
        result.borderColor = "rgba(var(--mui-palette-error-mainChannel) / 0.3)"
        result.color = "var(--mui-palette-error-dark, #c62828)"
        result.icon = "mdi:alert-circle-outline"
        result.tooltip = `Component not found: ${result.label}`
        return
    }
    result.label = macro?.label ?? macro?.name ?? result.label
    result.background = "rgba(var(--mui-palette-secondary-mainChannel) / 0.12)"
    result.borderColor = "rgba(var(--mui-palette-secondary-mainChannel) / 0.3)"
    result.color = "var(--mui-palette-secondary-dark, #7b1fa2)"
    result.icon = "mdi:puzzle-outline"
    result.tooltip = macro?.label ?? result.label
})
